const NotAuthorizedLayout = ({ children }) => {
    return (
      <div className="not-authorized-layout">
        <main>{children}</main>
      </div>
    );
  };
  export default NotAuthorizedLayout;